
<div style="position:relative; z-index: 100; width: 100%;    ">
	<nav class="navbar navbar-expand-md " style="position: fixed; width: 100%; top:0;   margin: 0;">
  <div class="container">
    <a style="width: 210px !important;" class="navbar-brand " [routerLink]="['']">
      <img class="img-fluid " src="assets/img/logo.png">
    </a>
    <button class="navbar-toggler" type="button" (click)="toggleNavbar()">
      <span class="navbar-toggler-icon"></span>
    </button>
<div class="collapse navbar-collapse" [class.show]="isNavbarOpen"
     style="max-height: 350px; overflow-y: auto;">      <ul class="navbar-nav mx-auto">
      <li class="nav-item">
    <a class="nav-link" [routerLink]="['']">Home</a>
  </li>

  <li class="nav-item">
    <a class="nav-link"  href="assets/staticpages2/about/index.html"
      >About Us</a
    >
  </li>
   <li class="nav-item">
    <a class="nav-link"  href="assets/staticpages2/network/index.html"
      >Network</a
    >
  </li>
   <li class="nav-item"  >
    <a class="nav-link" href="assets/staticpages2/home/index.html"
      >Hub</a
    >
  </li>
  
              <li class="nav-item">
                <a class="nav-link" href="https://Artisttweets.site"
                  >Tweet</a
                >
              </li>
              <li class="nav-item">
                <a class="nav-link" href="https://edutainmentalks.site"
                  >Talk</a
                >
              </li>
              <li class="nav-item">
                <a class="nav-link" href="https://umyomusic.com"
                  >Music</a
                >
              </li>
              <li class="nav-item">
                <a class="nav-link" href="https://Umyoevents.site"
                  >Events</a
                >
              </li>
              <li class="nav-item">
                <a class="nav-link" href="https://UPMRadio.site"
                  >Radio</a
                >
              </li>

              <li class="nav-item">
                <a
                  class="nav-link"
                  style="white-space: nowrap"
                  href="http://Live.umyoconvo.site/"
                  >Podcast</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  style="white-space: nowrap"
                  href="http://uchatyes.com/"
                  >ChatGpt</a
                >
              </li>

              <li class="nav-item">
                <a class="nav-link" style="white-space: nowrap" href="https://Umyoappt.site"
                  >Booking Appt</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  style="white-space: nowrap"
                  [routerLink]="['/cf']"
                  >Card Features</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  style="white-space: nowrap"
                  [routerLink]="['/package']"
                  >View Services</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  style="white-space: nowrap"
                  [routerLink]="['/ai']"
                  >Additional Features</a
                >
              </li>
              <li class="nav-item">
                <a href="https://Umyofan.site" class=" nav-link"
                  >Umyo Fan</a
                >
              </li>
              <li class="nav-item">
                <a href="https://www.htv10.tv/story/52583123/umyo-a-communitydriven-tech-revolution" class=" nav-link"
                  >Press Release</a
                >
              </li>
      </ul>
    </div>
  </div>
</nav>
</div>
<!------- tab section end ---------->
<section id="table-pkg" style="margin-top: 200px;">
  <div class="container-fluid featurs pt-3 mt-3 mb-5">
    <div class="container">
      <div class="row g-4">
        <h2 class="text-center">Community To Business Branding</h2>
        <h4>
          UMYO Entertainment Community and Small Business Accountability
          Packages
        </h4>
        <div class="col-lg-3">
          <div class="bg2">
            <h3 class="mt-4 small">Small <br />Biz Package</h3>
            <div class="line"></div>
            <p>www.umyoentertainment.site/</p>
          </div>
          <div class="th">
            <h6>(109-$299 monthly)</h6>
          </div>
          <div class="th2">
            <h6>Membership Cards</h6>
          </div>
          <div class="th">
            <h6>IAM Pledge Cards</h6>
          </div>
          <div class="th2">
            <h6>Coupon Kiosk</h6>
          </div>
          <div class="th">
            <h6>Business Cards</h6>
          </div>
          <div class="th2">
            <h6>Daily Prize Giveaways</h6>
          </div>
          <div class="th">
            <h6>B2B Branding</h6>
          </div>
          <div class="th2">
            <h6>Email Branding</h6>
          </div>
          <div class="th">
            <h6>MP3 Branding</h6>
          </div>
          <div class="th2">
            <h6>Conference Platform</h6>
          </div>
          <div class="th">
            <h6>Commercial Contests Participation</h6>
          </div>
          <div class="th2">
            <h6>Additional Platforms Access</h6>
          </div>
          <div class="th">
            <h6>Community To Business Branding</h6>
          </div>
          <div class="th2">
            <h6>Networking Platforms</h6>
          </div>
        </div>
        <div class="col-lg-9">
          <div class="d-flex align-items-center">
            <div class="bgn">
              <img src="assets/img/logo2.png" />
              <h3>Starter Biz Package</h3>
            </div>
            <div class="bgn" style="background: #27b7be !important">
              <img src="assets/img/logo2.png" />
              <h3>Accountability Package</h3>
            </div>
            <div class="bgn" style="background: #f1c05a !important">
              <img src="assets/img/logo2.png" />
              <h3 class="h31">Free Package</h3>
              <h3 class="h3">
                Free<br />
                Package
              </h3>
            </div>
          </div>
          <div class="th padd">
            <div class="icon">
              <h6>($49-$109 monthly)</h6>
              <h6>($5.99 - $19.99 monthly)</h6>
              <h6>Free</h6>
            </div>
          </div>
          <div class="th2 padd">
            <div class="icon">
              <i class="fa fa-check"></i>
              <i class="fa fa-check"></i>
              <i class="fa fa-check"></i>
            </div>
          </div>
          <div class="th padd">
            <div class="icon">
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
            </div>
          </div>
          <div class="th2 padd">
            <div class="icon">
              <i class="fa fa-close" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
            </div>
          </div>
          <div class="th padd">
            <div class="icon">
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
            </div>
          </div>
          <div class="th2 padd">
            <div class="icon">
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
            </div>
          </div>
          <div class="th padd">
            <div class="icon">
              <i class="fa fa-close" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
            </div>
          </div>
          <div class="th2 padd">
            <div class="icon">
              <i class="fa fa-close" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
            </div>
          </div>
          <div class="th padd">
            <div class="icon">
              <i class="fa fa-close" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
            </div>
          </div>
          <div class="th2 padd">
            <p>
              24/7 365 ( no time limits, live stream, podcast, webinar; $5.99 &
              up)
            </p>
            <!-- <i class="fa fa-check" aria-hidden="true"></i>
                    <i class="fa fa-check" aria-hidden="true"></i>
                    <i class="fa fa-check" aria-hidden="true"></i> -->
          </div>
          <div class="th padd">
            <div class="icon">
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
            </div>
          </div>
          <div class="th2 padd">
            <div class="icon">
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
            </div>
          </div>
          <div class="th padd">
            <div class="icon">
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
            </div>
          </div>
          <div class="th2 padd">
            <div class="icon">
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="row g-4">
        <h4 class="mt-5 pt-5">
          UMYO Entertainment Community Accountability & Business Cards Search
          Engine
        </h4>
        <div class="col-lg-3">
          <div class="bg2">
            <h4>Basic <br />Biz Package</h4>
            <div class="line"></div>
            <p>www.umyoentertainment.site/</p>
          </div>
          <div class="th">
            <h6>(10k monthly)</h6>
          </div>
          <div class="th2">
            <h6>Uchatyes.com</h6>
          </div>
          <div class="th">
            <h6>Standing Kiosk</h6>
          </div>
          <div class="th2">
            <h6>Sports Mag</h6>
          </div>
          <div class="th">
            <h6>Coupon Kiosk</h6>
          </div>
          <div class="th2">
            <h6>Commercial</h6>
          </div>
          <div class="th">
            <h6>EPK</h6>
          </div>
          <div class="th2">
            <h6>Google Ads</h6>
          </div>
          <div class="th">
            <h6>SEO</h6>
          </div>
          <div class="th2">
            <h6>SMS Marketing</h6>
          </div>
          <div class="th">
            <h6>Unlimited Cards</h6>
          </div>
          <div class="th2">
            <h6>B2B Branding</h6>
          </div>
          <div class="th">
            <h6>Email Branding</h6>
          </div>
          <div class="th2">
            <h6>Sponsor Ambassador</h6>
          </div>
          <div class="th">
            <h6>MP3 Branding</h6>
          </div>
          <div class="th2">
            <h6>Virtual Website</h6>
          </div>
          <div class="th">
            <h6>Marketing Manager</h6>
          </div>
          <div class="th2">
            <h6>Campaign Marketing</h6>
          </div>
          <div class="th">
            <h6>Commercial Contests</h6>
          </div>
          <div class="th2">
            <h6>Social Media Influencer</h6>
          </div>
          <div class="th">
            <h6>Youth Social Media Branding</h6>
          </div>
          <div class="th2">
            <h6>Full Platforms Access & Features</h6>
          </div>
        </div>
        <div class="col-lg-9">
          <div class="d-flex align-items-center">
            <div class="bgn bgn21">
              <img src="assets/img/logo2.png" />
              <h3>Custom Biz Package</h3>
            </div>
            <div class="bgn bgn21" style="background: #27b7be !important">
              <img src="assets/img/logo2.png" />
              <h3>Premium Biz Package</h3>
            </div>
            <div class="bgn bgn21" style="background: #f1c05a !important">
              <img src="assets/img/logo2.png" />
              <h3>Bronze Biz Package</h3>
            </div>
            <div class="bgn bgn21" style="background: #000 !important">
              <img src="assets/img/logo2.png" />
              <h3>Bronze Biz Package</h3>
            </div>
          </div>
          <div class="th thb">
            <div class="icon">
              <h6>(5k monthly)</h6>
              <h6>(3k monthly)</h6>
              <h6>(1k monthly)</h6>
              <h6>($500)</h6>
            </div>
          </div>
          <div class="th2 thb">
            <div class="icon">
              <i class="fa fa-check"></i>
              <i class="fa fa-check"></i>
              <i class="fa fa-check"></i>
              <i class="fa fa-close"></i>
            </div>
          </div>
          <div class="th thb padd">
            <div class="icon">
              <p>Floor Kiosk</p>
              <!-- <i class="fa fa-check" aria-hidden="true"></i> -->
              <i class="fa fa-close" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
            </div>
          </div>
          <div class="th2 thb">
            <div class="icon">
              <i class="fa fa-close" aria-hidden="true"></i>
              <p class="ml-auto">ADD</p>
              <p>LOGO</p>
              <p>Virtual Card</p>
              <!-- <i class="fa fa-check" aria-hidden="true"></i>
                    <i class="fa fa-check" aria-hidden="true"></i>
                    <i class="fa fa-check" aria-hidden="true"></i> -->
            </div>
          </div>
          <div class="th thb">
            <div class="icon">
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
            </div>
          </div>
          <div class="th2 thb">
            <div class="icon">
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
            </div>
          </div>
          <div class="th thb">
            <div class="icon">
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
            </div>
          </div>
          <div class="th2 thb">
            <div class="icon">
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
            </div>
          </div>
          <div class="th thb">
            <div class="icon">
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
            </div>
          </div>
          <div class="th2 thb">
            <p>Null</p>
            <!-- <i class="fa fa-check" aria-hidden="true"></i>
                    <i class="fa fa-check" aria-hidden="true"></i>
                    <i class="fa fa-check" aria-hidden="true"></i> -->
          </div>
          <div class="th thb">
            <div class="icon">
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
            </div>
          </div>
          <div class="th2 thb">
            <div class="icon">
              <p>Null</p>
            </div>
          </div>
          <div class="th thb">
            <div class="icon">
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
            </div>
          </div>
          <div class="th2 thb">
            <div class="icon">
              <p>Null</p>
            </div>
          </div>
          <div class="th thb">
            <div class="icon">
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
            </div>
          </div>
          <div class="th2 thb">
            <div class="icon">
              <p>Null</p>
            </div>
          </div>
          <div class="th thb">
            <div class="icon">
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
            </div>
          </div>
          <div class="th2 thb">
            <div class="icon">
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
            </div>
          </div>
          <div class="th thb">
            <div class="icon">
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
            </div>
          </div>
          <div class="th2 thb">
            <div class="icon">
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
            </div>
          </div>
          <div class="th thb">
            <div class="icon">
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
              <i class="fa fa-close" aria-hidden="true"></i>
            </div>
          </div>
          <div class="th2 thb">
            <div class="icon">
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
              <i class="fa fa-check" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


<footer>
  <div class="container">
    <h3>Own Your Platform. Build Your Future. Join the UMYO Ent Hub.</h3>
    <h6>UMYO Ent Hub introduces a comprehensive digital card directory and networking platform. Artists, creatives, and businesses can connect, share, and grow together — all in one supportive digital ecosystem. This is where the entertainment industry meets opportunity, exposure, and success.</h6>
  </div>
</footer>